import React, { useMemo } from 'react'
import { List, Map } from 'immutable'
import TileGridV2 from '../TileGrid.v2/index'
import Loading, { LOADING_ICON_BLUE_DARK_BG_WHITE } from '../Loading/index'
import TileV2Placeholder from '../Tile.v2/Tile.v2Placeholder'
import Button, { TYPES as BUTTON_TYPES } from '../Button/index'
import {
  createUpstreamContext,
  SCREEN_TYPE_SEARCH_PAGE,
} from '../../services/upstream-context/index'
import { STORE_KEY_SEARCH } from '../../services/store-keys/index'

interface TraditionalResultsProps {
  tileData: List<Map<string, unknown>>
  loading: boolean
  totalCount: number
  loadMore?: (() => void) | null
  q: string
  staticText: Map<string, unknown>
}

export default function TraditionalResults ({
  tileData,
  loading,
  totalCount,
  loadMore = null,
  q,
  staticText,
}: TraditionalResultsProps): React.ReactElement {
  const upstreamContext = useMemo(
    () => createUpstreamContext({
      screenType: SCREEN_TYPE_SEARCH_PAGE,
      screenParam: q,
      storeKey: STORE_KEY_SEARCH,
    }),
    [q],
  )

  const hasMore = tileData.size < totalCount
  const noResultsLabel = (staticText.getIn(['data', 'noResults']) as string)
    || 'No results found for your search.'
  const loadMoreLabel = (staticText.getIn(['data', 'loadMore']) as string)
    || 'Load More'

  return (
    <div className="ai-guide-search__traditional-results">
      {loading && tileData.size === 0 && (
        <div className="ai-guide-search__tile-placeholders-wrapper">
          <div className="ai-guide-search__tile-placeholders">
            <TileV2Placeholder display="default" />
            <TileV2Placeholder display="default" />
            <TileV2Placeholder display="default" />
            <TileV2Placeholder display="default" />
            <TileV2Placeholder display="default" />
          </div>
          <div className="ai-guide-search__tile-placeholders-overlay">
            <Loading visible icon={LOADING_ICON_BLUE_DARK_BG_WHITE} />
          </div>
        </div>
      )}

      {!loading && tileData.size === 0 && q && (
        <p className="ai-guide-search__traditional-empty">{noResultsLabel}</p>
      )}

      {tileData.size > 0 && (
        <>
          <TileGridV2
            tileData={tileData}
            upstreamContext={upstreamContext}
            adminTitle="Search Results"
            sectionIndex={0}
            rowPlacement={0}
          />
          {hasMore && loadMore && (
            <div className="ai-guide-search__load-more">
              <Button
                type={BUTTON_TYPES.GHOST}
                onClick={loadMore}
                disabled={loading}
              >
                {loadMoreLabel}
              </Button>
            </div>
          )}
        </>
      )}
    </div>
  )
}
